import Popper from 'vue3-popper'
import 'regenerator-runtime/runtime'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('Popper', Popper)
  nuxtApp.vueApp.component('popper', Popper)
})
